<template>
  <div>
    <!-- Boite panier vide -->
    <v-card
      v-if="coursNonComplets.length == 0 && coursComplets.length == 0"
      class="rounded-0 pa-7 w-100 mb-6"
      elevation="0"
    >
      {{ $t("Panier.PanierVide") }}
    </v-card>

    <!-- Boite Inscriptions à payer -->
    <v-card
      v-if="coursNonComplets.length > 0"
      class="rounded-0 pa-7 w-100 mb-6"
      elevation="0"
    >
      <v-row class="pb-2">
        <v-col cols="12">
          <label class="titre-boite">{{ $t("Panier.BoiteInscriptionsPayer.Titre") }}</label>
        </v-col>
      </v-row>
      <div
        v-for="coursPanier in coursNonComplets"
        v-bind:key="coursPanier.id"
      >
        <v-row class="py-2">
          <v-col
            v-if="!estPanierPaiement"
            cols="1"
            style="align-items: center; display: flex;"
          >
            <v-icon
              v-on:click.stop="supprimerPanier(coursPanier)"
              class="icone-supprimer"
            >
              mdi-delete
            </v-icon>
          </v-col>
          <v-col :cols="estPanierPaiement ? '10' : '9'">
            <v-col
              cols="12"
              class="py-0"
            >
              <label class="labelTitreCours font-weight-medium">
                {{ coursPanier.titre }}
              </label>
            </v-col>
            <v-col
              cols="12"
              class="py-0"
            >
              <label style="font-size: 12px; color: gray">
                {{ coursPanier.codeMatiere }}
              </label>
            </v-col>
          </v-col>
          <v-col
            cols="2"
            class="text-end"
          >
            <label
              class="labelPrix"
              style="color: gray"
            >
              {{ affichagePrix(coursPanier) }}$
            </label>
          </v-col>
        </v-row>

        <v-divider style="width: 100%"></v-divider>
      </div>

      <v-row class="mt-1">
        <v-col
          cols="10"
          style="text-align: right; align-self: center"
        >
          <label style="font-size: 20px; line-height: 0px">
            {{ $t("Panier.BoiteInscriptionsPayer.Total") }}
          </label>
        </v-col>
        <v-col
          cols="2"
          style="align-self: center"
          class="text-end"
        >
          <label
            class="labelPrix"
            style="color: gray"
          >{{ calculerPrixTotalPanier }}$</label>
        </v-col>
      </v-row>
    </v-card>

    <!-- Boite Inscriptions mises sur la liste d'attente -->
    <v-card
      v-if="coursComplets.length > 0"
      class="rounded-0 pa-7"
      elevation="0"
      style="width: 100%"
    >
      <v-row class="pb-2">
        <v-col cols="12">
          <label class="titre-boite">{{ $t("Panier.BoiteInscriptionsListeAttente.Titre") }}</label>
        </v-col>
      </v-row>

      <div
        v-for="coursPanier in coursComplets"
        v-bind:key="coursPanier.id"
      >
        <v-row class="py-2">
          <v-col
            v-if="!estPanierPaiement"
            cols="1"
            style="align-items: center; display: flex;"
          >
            <v-icon
              v-on:click.stop="supprimerPanier(coursPanier)"
              class="icone-supprimer"
            >
              mdi-delete
            </v-icon>
          </v-col>
          <v-col :cols="estPanierPaiement ? '12' : '11'">
            <v-col
              cols="12"
              class="py-0"
            >
              <label class="labelTitreCours font-weight-medium">
                {{ coursPanier.titre }}
              </label>
            </v-col>
            <v-col
              cols="12"
              class="py-0"
            >
              <label style="font-size: 12px; color: gray">
                {{ coursPanier.codeMatiere }}
              </label>
            </v-col>
          </v-col>
        </v-row>

        <v-divider style="width: 100%"></v-divider>
      </div>

      <v-row class="mt-1">
        <v-col cols="12">
            <label class="font-weight-medium"
                   style="font-size: 15px;">
                {{ $t("Panier.BoiteInscriptionsListeAttente.Note", { delaiInscription: this.appStore.modele.optionRegionale.delaiInscription }) }}
            </label>
          <p style="margin-top:1rem"><i>{{ $t('avertissement.placeNonGarantie') }}</i></p>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import csqcOutils from '@/outils/CSQCOutils';
import useInscriptionStore from '@/store/inscriptionStore';
import usePanierStore from '@/store/panierStore';
import useAppStore from '@/store/appStore';
import csqcOutilsCoursEte from '@/outils/CSQCOutilsCoursEte';

const racineLocalStorage = 'csqc_coursEte_';
const selectionInscriptionLocalStorage = 'selectionInscription';
const localStoragePanier = 'Panier';

export default {
  name: 'PanierComposant',
  data() {
    return {
      provenanceElevePanier: 0,
      estScolariseMaison: false,
      estCSSMembre: false,
      estCSSExterne: false,
      estCSSEcolePrive: false,
    };
  },
  props: {
    estPanierPaiement: Boolean,
  },
  setup() {
    const inscriptionStore = useInscriptionStore();
    const panierStore = usePanierStore();
    const appStore = useAppStore();

    return { inscriptionStore, panierStore, appStore };
  },
  created() {
    this.updateProvenanceEleve();
  },
  methods: {
    supprimerPanier(cours) {
      const message = {
        title: this.$t('boutique.dialog.Suppression'),
        body: `${this.$t('boutique.dialog.SouhaitezVousRetirer')}<b>${cours.titre} (${cours.codeMatiere})</b> ${this.$t('boutique.dialog.VotrePanier')}?`,
      };
      this.$dialog
        .confirm(message, {
          loader: true,
        })
        .then(async (dialog) => {
          const coursPanierAvant = csqcOutils.Cloner(
            this.panierStore.listeCoursPanier,
          );

          const coursPanierRetrait = coursPanierAvant.filter(
            (x) => x.id !== cours.id,
          );

          await this.panierStore.definirListeCoursPanier(coursPanierRetrait);

          const jsonCoursPanier = JSON.stringify(coursPanierRetrait);
          localStorage.setItem(
            racineLocalStorage + localStoragePanier,
            jsonCoursPanier,
          );
          dialog.close();
        });
    },
    affichagePrix(cours) {
      let estOffertGratuitement = false;

      if (cours.estGratuit != null) {
        estOffertGratuitement = cours.estGratuit;
      } else {
        const organismesGratuit = this.inscriptionStore.listeOrganismeGratuit;

        // Vérifiez que la réponse est bien un tableau
        if (!Array.isArray(organismesGratuit)) {
          return null;
        }

        const organisme = organismesGratuit.find((org) => org.organismeId === this.provenanceElevePanier);
        estOffertGratuitement = organisme != null;
      }

      // Si l'organisme offre les cours gratuits
      if (estOffertGratuitement) {
        if (this.estScolariseMaison) {
          return cours.prixScolarise;
        }

        return 0;
      }
      if (this.estScolariseMaison) {
        return cours.prixScolarise;
      } if (this.estCSSMembre) {
        return cours.prixCSSMembre;
      } if (this.estCSSExterne) {
        return cours.prixExterne;
      } if (this.estCSSEcolePrive) {
        return cours.prixPrive;
      }

      return null;
    },
    updateProvenanceEleve() {
      this.provenanceElevePanier = localStorage.getItem(racineLocalStorage + selectionInscriptionLocalStorage);

      this.estScolariseMaison = false;
      this.estCSSMembre = false;
      this.estCSSExterne = false;
      this.estCSSEcolePrive = false;

      if (csqcOutilsCoursEte.EstScolariseMaison()) {
        this.estScolariseMaison = true;
      } else if (csqcOutilsCoursEte.EstCSSMembre()) {
        this.estCSSMembre = true;
      } else if (csqcOutilsCoursEte.EstCSSExterne()) {
        this.estCSSExterne = true;
      } else if (csqcOutilsCoursEte.EstPrive()) {
        this.estCSSEcolePrive = true;
      }
    },
  },
  computed: {
    calculerPrixTotalPanier() {
      const organismesGratuit = this.inscriptionStore.listeOrganismeGratuit;

      // Vérifiez que la réponse est bien un tableau
      if (!Array.isArray(organismesGratuit)) {
        return null;
      }

      const organisme = organismesGratuit.find((org) => org.organismeId === this.provenanceElevePanier);
      let prixTotal = 0;

      if (this.coursNonComplets != null) {
        this.coursNonComplets.forEach((item) => {
          // Si l'organisme offre les cours gratuits
          if (organisme != null) {
            if (this.estScolariseMaison && !organisme.scolariseMaison) {
              prixTotal += item.prixScolarise;
            }

            prixTotal += 0;
          } else if (this.estScolariseMaison) {
            prixTotal += item.prixScolarise;
          } else if (this.estCSSMembre) {
            prixTotal += item.prixCSSMembre;
          } else if (this.estCSSExterne) {
            prixTotal += item.prixExterne;
          } else if (this.estCSSEcolePrive) {
            prixTotal += item.prixPrive;
          }
        });
      }

      return prixTotal;
    },

    coursNonComplets() {
      return this.panierStore.listeCoursPanier.filter((c) => !c.estListeAttente);
    },
    coursComplets() {
      return this.panierStore.listeCoursPanier.filter((c) => c.estListeAttente);
    },
  },
};
</script>

<style scoped>

 .labelPrix {
     white-space: nowrap;
 }

.labelTitreCours{
    white-space: none;
}

.titre-boite {
  font-size: 20px;
  line-height: 0;
  font-weight: 500;
  text-decoration: underline;
}

.icone-supprimer {
  font-size: 33px;
  color: black;
  vertical-align: middle;
  cursor: pointer;
}

</style>
